import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Megaphone, Trash2, Loader2 } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Tab „Anunț": mesaj banner in-app, vizibil tuturor userilor (fără email,
// ca să nu generăm spam) — un singur anunț activ la un moment dat.
export function AnnouncementPanel() {
  const [mesaj, setMesaj] = useState("");
  const [activ, setActiv] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/announcement/active`, { withCredentials: true })
      .then((r) => setActiv(r.data.announcement))
      .finally(() => setLoading(false));
  }, []);

  const publica = async () => {
    if (mesaj.trim() === "") {
      toast.error("Scrie un mesaj");
      return;
    }
    setBusy(true);
    try {
      const r = await axios.post(`${API}/admin/announcement`, { message: mesaj }, { withCredentials: true });
      setActiv(r.data);
      setMesaj("");
      toast.success("Anunț publicat — vizibil tuturor userilor");
    } catch {
      toast.error("Publicarea a eșuat");
    } finally {
      setBusy(false);
    }
  };

  const sterge = async () => {
    setBusy(true);
    try {
      await axios.delete(`${API}/admin/announcement`, { withCredentials: true });
      setActiv(null);
      toast.success("Anunț retras");
    } catch {
      toast.error("Ștergerea a eșuat");
    } finally {
      setBusy(false);
    }
  };

  if (loading) return <Loader2 className="h-6 w-6 animate-spin text-emerald-600 mx-auto mt-10" />;

  return (
    <div className="space-y-4" data-testid="announcement-panel">
      {activ ? (
        <div className="rounded-2xl bg-amber-50 border border-amber-200 p-4">
          <div className="flex items-center gap-2 mb-2">
            <Megaphone className="h-4 w-4 text-amber-600" />
            <p className="text-xs font-bold text-amber-700">Anunț activ acum, vizibil tuturor</p>
          </div>
          <p data-testid="active-announcement-text" className="text-sm text-amber-800">{activ.message}</p>
          <Button
            data-testid="clear-announcement-btn"
            onClick={sterge}
            disabled={busy}
            variant="outline"
            className="mt-3 rounded-xl border-amber-300 text-amber-700 hover:bg-amber-100"
          >
            <Trash2 className="h-4 w-4 mr-1.5" /> Retrage anunțul
          </Button>
        </div>
      ) : (
        <p className="text-sm text-slate-400">Niciun anunț activ momentan.</p>
      )}

      <div>
        <p className="text-sm font-semibold text-slate-700 mb-2">Publică un anunț nou (înlocuiește anunțul curent)</p>
        <Textarea
          data-testid="announcement-textarea"
          value={mesaj}
          onChange={(e) => setMesaj(e.target.value)}
          placeholder="Ex: Funcție nouă: reamintiri automate de datorii! 🎉"
          className="rounded-xl min-h-[90px]"
        />
        <Button
          data-testid="publish-announcement-btn"
          onClick={publica}
          disabled={busy}
          className="mt-2 w-full rounded-xl bg-emerald-600 hover:bg-emerald-700 font-bold"
        >
          Publică pentru toți userii
        </Button>
      </div>
    </div>
  );
}
